<div gdColumns="repeat(auto-fill, minmax(250px, 1fr))" gdGap="10px" [formGroup]="form">
	<mat-form-field>
		<input required autocomplete="user-street-address" matInput placeholder="Street Address"
			formControlName="address1" maxlength="100" />
		<mat-error *ngIf="form.get('address1').hasError('required')">Required</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input autocomplete="user-suite-number" matInput placeholder="Suite Number" formControlName="address2"
			maxlength="100" />
	</mat-form-field>
	<mat-form-field>
		<mat-select required formControlName="country" placeholder="Country" (selectionChange)="onCountryChanged()">
			<mat-option *ngFor="let country of countries$ | async" [value]="country.countryCode">
				{{ country.countryName }}
			</mat-option>
		</mat-select>
		<mat-error *ngIf="form.get('country').hasError('required')">Required</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input required autocomplete="user-city" matInput placeholder="City" formControlName="city" maxlength="50" />
		<mat-error *ngIf="form.get('city').hasError('required')">Required</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input required autocomplete="off" matInput placeholder="State" formControlName="state"
			[matAutocomplete]="state" maxlength="3" />
		<mat-autocomplete #state="matAutocomplete">
			<mat-option *ngFor="let state of filteredStates$ | async" [value]="state.code">
				{{ state.name }}
			</mat-option>
		</mat-autocomplete>
		<mat-error *ngIf="form.get('state').hasError('invalidItem')">
			Must be a valid state from the dropdown list.
		</mat-error>
		<mat-error *ngIf="form.get('state').hasError('required')">Required</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input autocomplete="user-zip-code" matInput placeholder="Zip Code" formControlName="zipCode" maxlength="10" />
	</mat-form-field>
</div>